export default __webpack_public_path__ + "static/media/complementary--height-limit--g2.5f8c440f.png";